var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66793 2C1.93922 2 1.33459 2.60462 1.33459 3.33333V11.3333C1.33459 12.062 1.93922 12.6667 2.66793 12.6667H12.0013L14.6679 15.3333L14.6601 3.33203C14.6601 2.60332 14.0547 2 13.3268 2H2.66793ZM2.66793 3.33333H13.3268L13.332 12.112L12.5533 11.3333H2.66793V3.33333ZM4.66663 5.33333V6.66667H11.3333V5.33333H4.66663ZM4.66663 8V9.33333H9.33329V8H4.66663Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.ee156b10fdc9abca23f7f5bcebbcbdf9.svg";
export { ForwardRef as ReactComponent };